<template>
  <div class="checkout-shopping-cart">
    <mdc-grid-container class="d-none d-sm-block">
      <mdc-grid class="checkout-shopping-table">
        <mdc-grid-cell :cols="12">
          <mdc-grid class="checkout-shopping-cart-header checkout-shopping-cart-row">
            <mdc-grid-cell :cols="6">
              <h4>DESCRIPTION</h4>
            </mdc-grid-cell>
            <!-- <mdc-grid-cell :cols="2">
              <h4>QTY</h4>
            </mdc-grid-cell> -->
            <!-- <mdc-grid-cell :cols="2">
              <h4>PRICE</h4>
            </mdc-grid-cell> -->
            <mdc-grid-cell
              :cols="6"
              class="text-right"
            >
              <h4>TOTAL</h4>
            </mdc-grid-cell>
          </mdc-grid>
        </mdc-grid-cell>
        <mdc-grid-cell
          v-for="product in products"
          :key="product.id"
          class="checkout-shopping-cart-row"
          :cols="12"
        >
          <mdc-grid>
            <mdc-grid-cell :cols="8">
              <small v-text="product.name" />
            </mdc-grid-cell>
            <!-- <mdc-grid-cell :cols="2">
              <small v-text="product.qty || 1" />
            </mdc-grid-cell> -->
            <!-- <mdc-grid-cell :cols="2">
              <small>{{product.sku.price | currency}}</small>
            </mdc-grid-cell> -->
            <mdc-grid-cell
              :cols="4"
              class="text-right"
            >
              <small v-text="product.total" />
            </mdc-grid-cell>
            <!-- <mdc-grid-cell
              :cols="1"
              class="mt-1"
            >
              <i class="material-icons">clear</i>
            </mdc-grid-cell> -->
          </mdc-grid>
        </mdc-grid-cell>
      </mdc-grid>
      <!--      <mdc-grid class="checkout-tally pt-4">-->
      <!--        <mdc-grid-cell :cols="12">-->
      <!--          <currency-selector-->
      <!--            :value="currencyCode"-->
      <!--            @input="onCurrencyChange"-->
      <!--          />-->
      <!--        </mdc-grid-cell>-->
      <!--      </mdc-grid>-->
      <mdc-grid class="checkout-tally pt-4">
        <mdc-grid-cell :cols="8">
          <p class="lead checkout-total font-weight-bold text-right mb-0">
            Amount due
          </p>
        </mdc-grid-cell>
        <mdc-grid-cell :cols="4">
          <p
            class="lead checkout-total font-weight-bold text-right mb-0"
            v-text="total"
          />
        </mdc-grid-cell>
      </mdc-grid>
    </mdc-grid-container>
    <div class="d-block d-sm-none mobile-summary mb-4">
      <div class="d-flex justify-content-between">
        <div class="">
          <p class="lead mb-0">
            Order summary
          </p>
        </div>
        <div class="">
          <p
            class="lead checkout-total font-weight-bold text-right mb-0"
            v-text="total"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import MdcGrid from '../material/Grid'
import MdcGridCell from '../material/GridCell'
// import MdcSelectField from '../material/SelectField'
import MdcGridContainer from '../material/GridContainer'
import CurrencySelector from './CurrencySelector'

export default {
  components: {
    MdcGrid,
    MdcGridCell,
    // MdcSelectField,
    MdcGridContainer,
    CurrencySelector
  },
  props: {
    total: {
      type: String,
      default: ''
    },
    products: {
      type: Array,
      default () {
        return []
      }
    },
    currencyCode: {
      type: String,
      default: 'USD'
    }
  },
  data () {
    return {}
  },
  methods: {
    onCurrencyChange (code) {
      this.$emit('onCurrencyChange', code)
    }
  }
}
</script>

<style lang="scss" scoped>
.checkout-shopping-cart {
  // max-width: 40rem;

  .checkout-shopping-table {
    row-gap: 0;
  }

  .mobile-summary {
    border: 2px solid #e3e8ee;
    background: #f7fafc;
    padding: 1em;
  }

  .material-icons {
    color: #9b9b9b;
    font-size: 18px;

  }

  .checkout-total {
    color: #e84f31;
  }

  .checkout-shopping-cart-header h4 {
    margin: 0;
    margin-bottom: 15px;
    font-size: 14px;
    font-weight: 500;
    color: #2a3046;
  }

  // .checkout-shopping-cart-row:nth-child(even) {
  .checkout-shopping-cart-row {
    border-bottom: solid 1px #e3e8ee;
    padding-top: 5px;
    padding-bottom: 5px;
    min-height: 40px;
    line-height: 32px;

    small {
      font-size: 14px;
      font-weight: 300;
      color: #4f566b;
    }
  }

  // tr:nth-child(odd) {
  //   background: #FFF
  // }
}
</style>
